export default __webpack_public_path__ + "static/media/delegates__img.3f8c7c8d.png";